export const ERROR_MESSAGES = {
  NetworkError: 'Koneksi internet anda error, coba lagi dalam beberapa saat',
  SessionExpired:
    'Sesi berakhir sehingga Anda keluar otomatis. Silakan masuk lagi.',
}
